import _styled from '@emotion/styled/base';
import isPropValid from '@emotion/is-prop-valid';
import { Typography } from '@tablekit/typography';
import { mediaQuery } from '@tablekit/utils';
import { getSizeStyle, interactionStates } from '../utils/theme.js';
export { ElementAfter, ElementBefore } from '../utils/theme.js';

var ItemBaseContainer = _styled("span", process.env.NODE_ENV === "production" ? {
  target: "ewsqrct3"
} : {
  target: "ewsqrct3",
  label: "ItemBaseContainer"
})("box-sizing:border-box;", getSizeStyle, ";", Typography.Body2, ";width:", mediaQuery('width', function (value) {
  return value || '100%';
}), ";", function (_ref) {
  var shouldCenterAlignment = _ref.shouldCenterAlignment,
      hasOnlyIcon = _ref.hasOnlyIcon;
  return shouldCenterAlignment || hasOnlyIcon ? 'justify-content: center' : '';
}, ";align-items:center;text-decoration:none;cursor:pointer;&:focus{outline:none;text-decoration:none;}", interactionStates, " ", function (_ref2) {
  var customStyles = _ref2.customStyles;
  return customStyles;
}, ";");

var ItemBaseHtml = /*#__PURE__*/_styled(ItemBaseContainer, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return isPropValid(prop) && ['shouldCenterAlignment', 'interactionState', 'useVariantAsClass', 'size', 'borderPosition', 'isDisabled', 'isSelected', 'isHidden', 'hasOnlyIcon'].indexOf(prop.toString()) === -1;
  },
  target: "ewsqrct2"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return isPropValid(prop) && ['shouldCenterAlignment', 'interactionState', 'useVariantAsClass', 'size', 'borderPosition', 'isDisabled', 'isSelected', 'isHidden', 'hasOnlyIcon'].indexOf(prop.toString()) === -1;
  },
  target: "ewsqrct2",
  label: "ItemBaseHtml"
})();

var ItemBaseComponent = /*#__PURE__*/_styled(ItemBaseContainer, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return ['as', 'shouldCenterAlignment', 'interactionState', 'useVariantAsClass', 'size', 'borderPosition', 'isDisabled', 'isSelected', 'isHidden', 'hasOnlyIcon'].indexOf(prop.toString()) === -1;
  },
  target: "ewsqrct1"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return ['as', 'shouldCenterAlignment', 'interactionState', 'useVariantAsClass', 'size', 'borderPosition', 'isDisabled', 'isSelected', 'isHidden', 'hasOnlyIcon'].indexOf(prop.toString()) === -1;
  },
  target: "ewsqrct1",
  label: "ItemBaseComponent"
})();

var ItemContent = _styled("span", process.env.NODE_ENV === "production" ? {
  target: "ewsqrct0"
} : {
  target: "ewsqrct0",
  label: "ItemContent"
})("width:", function (_ref3) {
  var shouldCenterAlignment = _ref3.shouldCenterAlignment;
  return shouldCenterAlignment ? 'auto' : '100%';
}, ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;");

export { ItemBaseComponent, ItemBaseHtml, ItemContent };
